import stSponVestingAbi from "@/contracts/abis/SPONVesting.json";
import { stSponVestingContract } from "@/contracts/addresses";
import { ethers } from "ethers";
import {
  getContract,
  prepareContractCall,
  sendAndConfirmTransaction,
} from "thirdweb";
import type { Abi } from "thirdweb/utils";
import { Account } from "thirdweb/wallets";
import { chain, thirdWebClient } from "@/app/libs/thirdweb";

export interface VestingInfo {
  isInitialized: boolean;
  totalVestingShares: string;
  claimedShares: string;
  claimableShares: string;
  remainingShares: string;
}

export const getVestingInfoEthers = async (
  userAddress: string,
  provider: ethers.Provider
) => {
  try {
    const contract = new ethers.Contract(
      stSponVestingContract,
      stSponVestingAbi,
      provider
    );

    const result = await contract.getDistributionInfo(userAddress);

    const vestingInfo = {
      isInitialized: result[0],
      totalVestingShares: result[1].toString(),
      claimedShares: result[2].toString(),
      claimableShares: result[3].toString(),
      remainingShares: result[4].toString(),
    };

    console.log(`Vesting info for ${userAddress}:`, vestingInfo);
    return vestingInfo;
  } catch (error) {
    console.error("Error fetching vesting claim info:", error);
    throw error;
  }
};

export interface IClaimVestedParams {
  shares: bigint;
  proof: `0x${string}`[];
  account: Account;
}

export async function claimVested({
  shares,
  proof,
  account,
}: IClaimVestedParams) {
  const contract = getContract({
    client: thirdWebClient,
    chain,
    address: stSponVestingContract,
    // Without the ABI, thirdweb resolves one remotely to decode reverts. That
    // resolved ABI is missing the contract's custom errors, so a revert blows
    // up with `AbiErrorSignatureNotFoundError` instead of surfacing the reason.
    abi: stSponVestingAbi as unknown as Abi,
  });

  const transaction = prepareContractCall({
    contract,
    method: "function claimTokens(uint256 totalAmount, bytes32[] proof)",
    params: [shares, proof],
  });

  const transactionReceipt = await sendAndConfirmTransaction({
    transaction,
    account,
  });
  return transactionReceipt;
}

export const getClaimableAmountEthers = async (
  userAddress: string,
  amount: bigint,
  proof: string[],
  provider: ethers.Provider
) => {
  try {
    const contract = new ethers.Contract(
      stSponVestingContract,
      stSponVestingAbi,
      provider
    );

    const result = await contract.checkClaimableAmount(
      userAddress,
      amount,
      proof
    );

    const claimableShares = result;

    console.log(`Claimable amount for ${userAddress}:`, claimableShares);
    return claimableShares;
  } catch (error) {
    console.error("Error fetching claimable amount:", error);
    throw error;
  }
};
